import React, { useState, useMemo } from "react"
import { connect } from "react-redux"
import GasProjectGis from "./GasProjectGis"
import {
  getGasProjectFiles,
  getGasProjectsFullFilter,
  getListProjectProcessEng,
} from "../../store/actions"
import { withTranslation } from "react-i18next"

const GasProjectGisIndex = props => {
  return <GasProjectGis mainProps={props} />
}

const mapStateToProps = ({ GasProjects, GasProjectProcesses }) => ({
  lstGasProjectsFullFilter: GasProjects.lstGasProjectsFullFilter,
  lstGasProjectsFullFilterTotal: GasProjects.lstGasProjectsFullFilterTotal,
    lstProjectProcessEng: GasProjectProcesses.lstProjectProcessEng,
  lstProjectProcessEngTotal: GasProjectProcesses.lstProjectProcessEngTotal,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  loading: GasProjects.loading || GasProjectProcesses.loading,
  error: GasProjects.error || GasProjectProcesses.error,
  success: GasProjects.success || GasProjectProcesses.success,
})
const mapDispatchToProps = dispatch => ({
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onGetGasProjectsFullFilter: searchValue =>
    dispatch(getGasProjectsFullFilter(searchValue)),
    onGetListProjectProcessEng: searchValue =>
      dispatch(getListProjectProcessEng(searchValue)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GasProjectGisIndex))
